/* app/js/src/components/common/progress-stepper/progress-stepper.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 25px;
  align-self: stretch;
}
.step {
  display: flex;
  align-items: center;
  gap: 8px;
}
.step .marker {
  display: flex;
  align-items: center;
  gap: 10px;
}
.step .marker .position {
  width: 40px;
  color: rgba(0, 0, 0, 0.85);
  font-feature-settings: "clig" off, "liga" off;
  font-family: Open Sans;
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 45px;
  letter-spacing: 0.25px;
}
.step .text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: rgba(0, 0, 0, 0.85);
  font-feature-settings: "clig" off, "liga" off;
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  text-transform: uppercase;
}
/*# sourceMappingURL=progress-stepper.component.css.map */
